export default class SearchDropdown {

    constructor() {
        
        this.settings = {
            $searchIcon : $('.js-search-icon')
        };
        
        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$searchIcon != null ) {
            this.settings.$searchIcon.on('click', (e) => {
                const $this = $(e.currentTarget);
                $(document).ready(() => {
                    $('.js-search-dropdown').toggleClass('hidden');
                });
            });

            $('.js-search-close').on('click', () => {
                $('.js-search-dropdown').addClass('hidden');
            });
        }

    }
};

new SearchDropdown();